import React, { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import isArray from 'lodash/isArray';
import size from 'lodash/size';

import { useGetCars } from '../../hooks/react-query/useCarData';
import { useAssignDrivers, useSetPrimaryDriver } from '../../hooks/react-query/useDrivers';

import Footer from '../../components/cars/footer';
import AssignDriverView from '../../components/cars/assignDriverView';
import CarOverView from '../../components/cars/carOverView';
import SuccessPage from '../../components/cars/successPage';
import CarDetailsView from '../../components/cars/carDetailsView';
import CarOrderedList from '../../components/cars/carOrderedList';
import Header from '../../components/cars/header';
import LeasedCarList from '../../components/cars/leasedCarList';
import { useSearchParams } from 'react-router-dom';
import { CardListSkeletion } from '../../components/elements/skeletions';
import Container from '../../components/elements/container';
import EditCarView from '../../components/cars/editCarView';
import { queryClient } from '../../utils/queryClient';
import {
  QUERY_KEYS,
  imageStudioBaseUrl,
  myAvisUrl,
} from '../../config/constants';
import { OrderedCarOverViewMobile } from '../../components/cars/orderedCardOverView';
import { toast } from '../../components/ui/Toast/useToast';
import { Checkbox } from '../../components/ui';
import { getDriversByPlateNumberFn } from '../../transactions/drivers/drivers';
import { useQuery } from "@tanstack/react-query";
import usePersonStore from '../../store/personStore';

const { DRIVERS, CARS, ASSIGN_DRIVERS } = QUERY_KEYS;

const CarList = () => {
  let [searchParams] = useSearchParams();
  const [primary, setPrimary] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [leasedCarSearchTerm, setLeasedCarSearchTerm] = useState('');
  const { ref, inView } = useInView({ threshold: 0.4, child: true });
  // const [pageNumber, setPageNumber] = useState(1);
  const {
    data: carList,
    hasNextPage,
    fetchNextPage,
    isLoading,
  } = useGetCars(searchTerm);
  const { mutate: assignDriver, isLoading: isAssignDriverLoading } =
    useAssignDrivers();
  const { mutate: setPrimaryDriver, isLoading: isSettingPrimaryLoading } = useSetPrimaryDriver();
  // const [isMobileView, setMobileView] = useState(false);
  const [isAssignedView, setAssignedView] = useState(false);
  const [selectedCar, setSelectedCar] = useState();
  const [isExpended, setViewState] = useState(false);
  const [driverData, setDriverData] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [showSuccessView, setSuccessView] = useState(false);
  const [selectedOrderedCar, setSelectedOrderedCar] = useState(null);
  const [activeTab, setActiveTab] = useState(
    searchParams.get('active') === null ? 0 : 1
  );

  // ============ NEW =================

  const userData = usePersonStore((store) => store.userData);
  const hasAdminRole = userData && userData.isAdmin;

  const { data: assignedDriversList , isLoading: driversListLoading} = useQuery({
    queryKey: ['driversListPerCar', selectedCar?.plateno],
      queryFn: () => getDriversByPlateNumberFn(selectedCar?.plateno),
      staleTime: Infinity,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      enabled: !hasAdminRole,
      onSuccess: (data) => {},
  }); 
  // ============ NEW =================

  // useEffect(() => {
  //   let vw = Math.max(
  //     document.documentElement.clientWidth || 0,
  //     window.innerWidth || 0
  //   );
  //   console.log(vw)
  //   if (vw < 992) {
  //     setMobileView(true);
  //   }
  // }, []);

  useEffect(() => {
    if (inView && hasNextPage) {
      fetchNextPage();
    }
  }, [inView, fetchNextPage, hasNextPage]);



  const handleCardClick = (data) => {
    // ============ NEW =================
    if(!!selectedCar?.plateno) {
          queryClient.invalidateQueries({ queryKey: ['driversListPerCar', selectedCar?.plateno] });
        }
    // ============ NEW =================
    setSelectedCar(data);
  };

  const handleViewState = () => {
    setViewState(!isExpended);
  };

  const handleAssignDriver = () => {
    setAssignedView(true);
  };

  const handleBackClick = () => {
    setDriverData(null);
    setAssignedView(false);
    setSelectedCar(null);
    setViewState(false);
  };

  const handleDriverSelect = (selectedDriver) => {
    setDriverData(selectedDriver);
  };

  const handleAssignClick = () => {
    assignDriver(
      { plateno: selectedCar.plateno, id: driverData.id },
      {
        onSuccess: (response) => {
          if (response?.data && response?.data?.status === 'fail') {
            if (response.exceptions) {
              if (size(response.exceptions) > 0) {
                const exceptionsArray = isArray(response.exceptions);
                const message = exceptionsArray
                  ? response.exceptions.slice(-1)
                  : 'Παρουσιάστηκε κάποιο πρόβλημα';
                toast({
                  variant: 'destructive',
                  description: message || 'Παρουσιάστηκε κάποιο πρόβλημα',
                });
              }
            }
            setPrimary(false);
            setOpenModal(false);
          } else {
            queryClient.invalidateQueries({
              queryKey: [CARS, searchTerm],
            });
            queryClient.invalidateQueries({
              queryKey: [DRIVERS, selectedCar.plateno],
            });
            queryClient.invalidateQueries({
              queryKey: [ASSIGN_DRIVERS, selectedCar.plateno],
            });
            if(primary) { // if we invoke the make primary if there are no drivers, then add here if(primary || assignedDriversList?.data.length == 0)
              setPrimaryDriver(
                { userId: driverData.id, plateno: selectedCar.plateno },
                {
                  onSuccess: () => {
                    if (response?.data && response?.data?.status === 'fail') {
                      if (response.exceptions) {
                        if (size(response.exceptions) > 0) {
                          const exceptionsArray = isArray(response.exceptions);
                          const message = exceptionsArray
                            ? response.exceptions.slice(-1)
                            : 'Παρουσιάστηκε κάποιο πρόβλημα';
                          toast({
                            variant: 'destructive',
                            description: message || 'Παρουσιάστηκε κάποιο πρόβλημα',
                          });
                        }
                      }
                      setPrimary(false);
                      setOpenModal(false);
                    } else {
                    queryClient.invalidateQueries({
                      queryKey: [ASSIGN_DRIVERS, selectedCar.plateno],
                    });
                    setPrimary(false);
                    setOpenModal(false);
                    setSuccessView(true);
                    setAssignedView(false);
                    setViewState(false);
                  }
                  },
                }
              );
            }else{
              setPrimary(false);
              setOpenModal(false);
              setSuccessView(true);
              setAssignedView(false);
              setViewState(false);
            } 
          }
        },
      }
    );
  };

  const handleAssignNewDriverClick = () => {
    setSuccessView(false);
    setDriverData({});
    setSelectedCar(null);
  };

  const handleAssignDriverView = () => {
    setDriverData({});
    setSuccessView(false);
    setAssignedView(true);
  };

  const handleCarSearch = (value) => {
    setSearchTerm(value);
    setSelectedCar(null);
    setViewState(false);
  };

  const handleLeasedCarSearch = (value) => {
    setSelectedOrderedCar(null);
    setLeasedCarSearchTerm(value);
  };

  const handleOrderedCarSlection = (carData) => {
    setSelectedOrderedCar(carData);
  };

  if (activeTab) {
    return (
      <>
        <Container>
          <Header
            activeTab={activeTab}
            searchTerm={leasedCarSearchTerm}
            handleActiveTab={(value) => {
              setSearchTerm('');
              setLeasedCarSearchTerm('');
              if (value === 0) {
                setSelectedOrderedCar(null);
              }
              setActiveTab(value);
            }}
            handleCarSearch={handleLeasedCarSearch}
          >
            <div className="flex flex-col gap-4 max-lg:mb-[130px]">
              <div className="grid lg:grid-cols-4 gap-4">
                <CarOrderedList
                  searchTerm={leasedCarSearchTerm}
                  handleCarSelection={handleOrderedCarSlection}
                />
              </div>
            </div>
          </Header>
        </Container>
        {selectedOrderedCar ? (
          <OrderedCarOverViewMobile carData={selectedOrderedCar} />
        ) : (
          <></>
        )}
      </>
    );
  }

  if (
    !isAssignedView &&
    !showSuccessView &&
    !searchTerm &&
    carList &&
    carList.pages &&
    isArray(carList.pages) &&
    carList.pages[0]?.data &&
    !carList.pages[0]?.data?.length
  ) {
    return (
      <Container>
        <Header
          isList={false}
          activeTab={activeTab}
          searchTerm={searchTerm}
          handleActiveTab={(value) => {
            setSearchTerm('');
            setLeasedCarSearchTerm('');
            setActiveTab(value);
          }}
          handleCarSearch={handleCarSearch}
          selectedCar={selectedCar}
          handleAssignDriver={handleAssignDriver}
        >
          <div className="flex justify-center items-center">
            <p>
              Δεν έχεις αυτοκίνητα αυτή τη στιγμή. Μπες στο{' '}
              <a href={myAvisUrl} class="text-primary">
                MyAvis
              </a>
              &nbsp; για να ξεκινήσεις.
            </p>
          </div>
        </Header>
      </Container>
    );
  }

  return (
    <>
      <Container>
        {!isAssignedView && !showSuccessView ? (
          <Header
            isList={false}
            activeTab={activeTab}
            searchTerm={searchTerm}
            handleActiveTab={(value) => {
              setSearchTerm('');
              setLeasedCarSearchTerm('');
              setActiveTab(value);
            }}
            handleCarSearch={handleCarSearch}
            selectedCar={selectedCar}
            handleAssignDriver={handleAssignDriver}
          >
            <div className="flex flex-col gap-4 min-h-[70vh] max-lg:mb-[110px]">
              <div className="grid lg:grid-cols-4 gap-4">
                <ul
                  className={`gap-3 overflow-y-auto pe-3 max-h-[70vh] min-h-[70vh] h-fit scrollbar ${
                    isExpended
                      ? 'col-span-1 grid grid-cols-1'
                      : selectedCar
                      ? 'col-span-3 grid lg:grid-cols-3 content-start'
                      : 'col-span-3 grid lg:grid-cols-3 content-start'
                  }`}
                >
                  {isLoading && !carList ? (
                    <CardListSkeletion />
                  ) : (
                    <LeasedCarList
                      carRef={ref}
                      selectedCar={selectedCar}
                      carList={carList}
                      searchTerm={searchTerm}
                      handleCardClick={handleCardClick}
                    />
                  )}
                </ul>
                {isExpended ? (
                  <section className="col-span-3 w-full overflow-y-auto bg-white rounded-[12px]">
                    <CarDetailsView
                      selectedCar={selectedCar}
                      handleViewState={handleViewState}
                      handleAssignClick={handleAssignDriver}
                    />
                  </section>
                ) : (
                  <section
                    className={`max-lg:hidden w-full`}
                  >
                    <CarOverView
                      isExpended={isExpended}
                      selectedCar={selectedCar}
                      handleAssignClick={handleAssignDriver}
                      handleViewState={handleViewState}
                      hasDrivers={assignedDriversList?.data.length > 0}
                      isAdmin={hasAdminRole}
                    />
                  </section>
                )}
              </div>
            </div>
          </Header>
        ) : showSuccessView ? (
          <SuccessPage
            backButtonText="Επιστροφή στο My Cars"
            redirectButtonText="Προσθήκη νέου οδηγού"
            message={
              <div className="text-body flex flex-col items-center gap-2 text-center">
                Ο/Η {driverData?.firstName} {driverData?.lastName}
                {' '} έχει προστεθεί επιτυχώς στο {' '}
                {selectedCar.MakeName + ' ' + selectedCar.ModelName}
                <img
                  className="lg:hidden"
                  alt={`${selectedCar.MakeName}_${selectedCar.ModelName}`}
                  src={`${imageStudioBaseUrl}&&make=${selectedCar.MakeName}&modelFamily=${selectedCar.ModelName}&modelVariant=${selectedCar.ModelName}&powerTrain=hybrid&trim=eu&zoomType=fullScreen&width=400&angle=28`}
                />
              </div>
            }
            handleAssignClick={handleAssignDriverView}
            handleBackClick={handleAssignNewDriverClick}
          />
        ) : (
          <AssignDriverView
            carData={selectedCar}
            handleDriverSelect={handleDriverSelect}
            handleBackClick={handleBackClick}
          />
        )}
      </Container>
      {isAssignedView && (
        <Footer
          title={'Προσθήκη Οδηγού'}
          openModal={openModal}
          setOpenModal={setOpenModal}
          handleOkClick={handleAssignClick}
          disabled={!driverData?.id}
          modalTitle="Προσθήκη"
          message={
            <div className='flex flex-col gap-4'>
              <div className='flex flex-col items-center gap-2'>
                <p>
                Είσαι σίγουρος ότι θέλεις να προσθέσεις τον/την {' '}
                <strong>
                  {driverData?.firstName} {driverData?.lastName}
                </strong>
                  {' '}  ως οδηγό του αυτοκινήτου {' '}<strong>{selectedCar?.ModelName}</strong>;
                  </p>
                  {/* ============ NEW ================= */}
                    {assignedDriversList?.data.length > 0 ?
                      <div className='flex gap-2'>
                        <Checkbox checked={primary} onCheckedChange={(value) => { setPrimary(value);}}/>
                        <p className='text-sm'>Ορισμός ως κύριος οδηγός.</p>
                        </div>
                      : <p> Θα οριστεί αυτόματα και ως κύριος οδηγός. Στη συνέχεια, μπορείς να αλλάξεις τον κύριο οδηγό οποιαδήποτε στιγμή.</p>
                    }
                    {/* ============ NEW ================= */}
              </div>
            </div>
          }
          isLoading={isAssignDriverLoading || isSettingPrimaryLoading}
        />
      )}
      {selectedCar && !isAssignedView && !showSuccessView && (
        <div className="lg:hidden fixed bottom-0 w-full h-[94px] bg-white flex flex-col gap-3 p-3">
          <EditCarView
            selectedCar={selectedCar}
            handleAssignClick={handleAssignDriver}
          />
        </div>
      )}
    </>
  );
};

export default CarList;
